var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.375,
    y: 1.375,
    width: 19.25,
    height: 19.25,
    rx: 6,
    fill: "url(#paint0_radial_49_12)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.375,
    y: 1.375,
    width: 19.25,
    height: 19.25,
    rx: 6,
    fill: "url(#paint1_radial_49_12)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.375,
    y: 1.375,
    width: 19.25,
    height: 19.25,
    rx: 6,
    fill: "url(#paint2_radial_49_12)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 7.21875C15.8125 7.78829 15.3508 8.25 14.7812 8.25C14.2117 8.25 13.75 7.78829 13.75 7.21875C13.75 6.64921 14.2117 6.1875 14.7812 6.1875C15.3508 6.1875 15.8125 6.64921 15.8125 7.21875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.4375C12.8985 14.4375 14.4375 12.8985 14.4375 11C14.4375 9.10152 12.8985 7.5625 11 7.5625C9.10152 7.5625 7.5625 9.10152 7.5625 11C7.5625 12.8985 9.10152 14.4375 11 14.4375ZM11 13.0625C12.1391 13.0625 13.0625 12.1391 13.0625 11C13.0625 9.86091 12.1391 8.9375 11 8.9375C9.86091 8.9375 8.9375 9.86091 8.9375 11C8.9375 12.1391 9.86091 13.0625 11 13.0625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 10.725C4.125 8.41478 4.125 7.25968 4.5746 6.37729C4.97008 5.60112 5.60112 4.97008 6.37729 4.5746C7.25968 4.125 8.41478 4.125 10.725 4.125H11.275C13.5852 4.125 14.7403 4.125 15.6227 4.5746C16.3989 4.97008 17.0299 5.60112 17.4254 6.37729C17.875 7.25968 17.875 8.41478 17.875 10.725V11.275C17.875 13.5852 17.875 14.7403 17.4254 15.6227C17.0299 16.3989 16.3989 17.0299 15.6227 17.4254C14.7403 17.875 13.5852 17.875 11.275 17.875H10.725C8.41478 17.875 7.25968 17.875 6.37729 17.4254C5.60112 17.0299 4.97008 16.3989 4.5746 15.6227C4.125 14.7403 4.125 13.5852 4.125 11.275V10.725ZM10.725 5.5H11.275C12.4528 5.5 13.2534 5.50107 13.8723 5.55163C14.4751 5.60089 14.7834 5.69016 14.9985 5.79973C15.5159 6.06338 15.9366 6.48408 16.2003 7.00153C16.3098 7.21658 16.3991 7.52486 16.4484 8.12768C16.4989 8.74655 16.5 9.5472 16.5 10.725V11.275C16.5 12.4528 16.4989 13.2534 16.4484 13.8723C16.3991 14.4751 16.3098 14.7834 16.2003 14.9985C15.9366 15.5159 15.5159 15.9366 14.9985 16.2003C14.7834 16.3098 14.4751 16.3991 13.8723 16.4484C13.2534 16.4989 12.4528 16.5 11.275 16.5H10.725C9.5472 16.5 8.74655 16.4989 8.12768 16.4484C7.52486 16.3991 7.21658 16.3098 7.00153 16.2003C6.48408 15.9366 6.06338 15.5159 5.79973 14.9985C5.69016 14.7834 5.60089 14.4751 5.55163 13.8723C5.50107 13.2534 5.5 12.4528 5.5 11.275V10.725C5.5 9.5472 5.50107 8.74655 5.55163 8.12768C5.60089 7.52486 5.69016 7.21658 5.79973 7.00153C6.06338 6.48408 6.48408 6.06338 7.00153 5.79973C7.21658 5.69016 7.52486 5.60089 8.12768 5.55163C8.74655 5.50107 9.5472 5.5 10.725 5.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_49_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.25 15.8125) rotate(-55.3758) scale(17.5447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_49_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.5625 21.3125) rotate(-65.1363) scale(15.5335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_49_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.343751 2.0625) rotate(-8.1301) scale(26.7375 5.71887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.a7d041bf5b58feaf84e99c6b911ce62a.svg";
export { ForwardRef as ReactComponent };